<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <SearchTitle label='科室轮转情况报表' Url='/report/cycle/sectioncycle'></SearchTitle>
      <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
        <!--begin: Search Form -->
        <div class="m-form m-form--label-align-right">
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">管理单元：</label>
              </div>
              <div class="m-form__control">
                <el-select v-model="condition.secretarysec" filterable placeholder="全部" @change="ManageSecChange">
                  <el-option label="全部" value=""></el-option>
                  <el-option v-for="item in managesecOptions" :key="item.DictItemID" :label="item.DictItemName" :value="item.DictItemID">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">轮转科室：</label>
              </div>
              <div class="m-form__control">
                <el-select v-model="condition.section" filterable placeholder="全部">
                  <el-option label="全部" value=""></el-option>
                  <el-option v-for="item in secOptions" :key="item.DictItemID" :label="item.DictItemName" :value="item.DictItemID">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
          <SearchNormalText v-model='condition.truename' label='姓名'></SearchNormalText>
          <SearchNormalText v-model='condition.cardno' label='工号'></SearchNormalText>
          <ZPGLSearchDictItemSelect v-model='condition.stuspec' label='专业' :dictid='this.$utils.DictEnum.specialty'></ZPGLSearchDictItemSelect>
          <ZPGLSearchDictItemSelect v-model='condition.stuyear' label='届别' :dictid='this.$utils.DictEnum.stuyear'></ZPGLSearchDictItemSelect>
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">轮转时间：</label>
              </div>
              <div class="m-form__control">
                <el-date-picker v-model="condition.monthdate" type="month" placeholder="轮转时间" value-format="yyyy-MM">
                </el-date-picker>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">培训状态：</label>
              </div>
              <div class="m-form__control">
                <el-select v-model="condition.cpstatus" filterable placeholder="全部">
                  <el-option label="全部" value=""></el-option>
                  <el-option v-for="item in cpstatusOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
          <!-- <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">备注：</label>
              </div>
              <div class="m-form__control">
                <el-select v-model="condition.state" filterable placeholder="全部">
                  <el-option label="全部" value=""></el-option>
                  <el-option v-for="item in stateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div> -->
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">排序字段：</label>
              </div>
              <div class="m-form__control">
                <el-select v-model="condition.orderkey" filterable placeholder="全部">
                  <el-option label="全部" value=""></el-option>
                  <el-option v-for="item in orderOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">排序方式：</label>
              </div>
              <div class="m-form__control">
                <el-select v-model="condition.orderdesc" filterable placeholder="全部">
                  <el-option label="全部" value=""></el-option>
                  <el-option v-for="item in orderDescOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
        </div>
        <div style="clear: both;"></div>
        <div class="m--margin-top-10 m--margin-bottom-10" style="width: 100%;text-align: center;float: initial;">
          <SearchButton :url='searchUrl' ref="btnSearch"></SearchButton>
          <ExportButton :url='exportUrl' buttonname="导出"></ExportButton>
        </div>
        <!--end: Search Form -->
        <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
          <!--begin: Datatable -->
          <el-table v-loading="loading" :data="tableData" stripe style="width: 100%" size="medium">
            <el-table-column prop="CPStuName" label="姓名">
            </el-table-column>
            <el-table-column prop="CPStuNo" label="工号">
            </el-table-column>
            <el-table-column prop="SpecName" label="专业">
            </el-table-column>
            <el-table-column prop="StuYearName" label="届别">
            </el-table-column>
            <el-table-column prop="ManageSecName" label="管理单元">
            </el-table-column>
            <el-table-column prop="SecName" label="轮转科室">
            </el-table-column>
            <el-table-column label="轮转开始时间">
              <template slot-scope="scope">
                {{scope.row.CPBeginDate|formatDate}}
              </template>
            </el-table-column>
            <el-table-column label="轮转结束时间">
              <template slot-scope="scope">
                {{scope.row.CPEndDate|formatDate}}
              </template>
            </el-table-column>
            <!-- <el-table-column prop="State" label="备注">
            </el-table-column> -->
            <el-table-column label="状态">
              <template slot-scope="scope">
                <span v-if="scope.row.CPStatus == '1'">{{scope.row.CPStatusName}}</span>
                <span v-if="scope.row.CPStatus == '2'" style="color: green;">{{scope.row.CPStatusName}}</span>
                <span v-if="scope.row.CPStatus == '3'" style="color: red;">{{scope.row.CPStatusName}}</span>
              </template>
            </el-table-column>
          </el-table>
          <!--end: Datatable -->
          <div style="margin-top: 10px;text-align: center;" v-if="this.condition.recordCount > 0">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="condition.currentPage"
              :page-sizes="[2, 10, 20, 30, 40]" :page-size="condition.pageSize" layout="total, sizes, prev, pager, next, jumper"
              :total="condition.recordCount">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'SectionCycle',
    data() {
      return {
        condition: {
          username: '',
          rolelevel: '',
          secid: '',
          truename: '',
          cardno: '',
          section: '',
          stuyear: '',
          monthdate: '',
          stuspec: '',
          token: '',
          pageSize: 10,
          currentPage: 1,
          recordCount: 0,
          firstSearch: true,
          orderkey: '',
          orderdesc: '',
          state: '',
          secretarysec: '',
          cpstatus: ''
        },
        secOptions: [],
        managesecOptions: [],
        tableData: [],
        name: '',
        title: '',
        searchUrl: this.$utils.Url.zpgl + '/api/APICyclePlan/SectionCycle',
        exportUrl: this.$utils.Url.zpgl + '/api/APICyclePlan/SectionCycleOut',
        loading: true,
        orderOptions: [{
            value: 'CPStuName',
            label: '姓名'
          },
          {
            value: 'SecName',
            label: '轮转科室'
          },
          {
            value: 'CPBeginDate',
            label: '轮转开始时间'
          },
          {
            value: 'CPEndDate',
            label: '轮转结束时间'
          }
        ],
        orderDescOptions: [{
            value: 'OrderBy',
            label: '升序'
          },
          {
            value: 'OrderByDesc',
            label: '降序'
          }
        ],
        stateOptions: [{
            value: '未入科',
            label: '未入科'
          },
          {
            value: '已出科',
            label: '已出科'
          },
          {
            value: '入科月',
            label: '入科月'
          },
          {
            value: '出科月',
            label: '出科月'
          },
          {
            value: '轮转中',
            label: '轮转中'
          }
        ],
        cpstatusOptions: [{
          value: '1',
          label: '未入科'
        }, {
          value: '2',
          label: '已入科'
        }, {
          value: '3',
          label: '缺勤'
        }]
      }
    },
    filters: {
      formatDate(val) {
        var now = new Date(val)
        var y = now.getFullYear()
        var m = now.getMonth() + 1
        return y + '-' + (m < 10 ? '0' + m : m)
      }
    },
    methods: {
      // 调整每页显示数
      handleCurrentChange: function(val) {
        this.condition.firstSearch = false
        this.condition.currentPage = val
        this.$refs.btnSearch.Search()
      },
      // 分页操作
      handleSizeChange: function(val) {
        this.condition.firstSearch = false
        this.condition.pageSize = val
        this.condition.currentPage = 1
        this.$refs.btnSearch.Search()
      },
      LoadManageSec: function() {
        var args = {
          token: this.condition.token,
          username: this.condition.username,
          rolelevel: this.condition.rolelevel
        }
        var that = this
        this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIDictItem/ManageSecionList', args, function(data) {
          that.managesecOptions = data.Data
        }, null, null, null)
      },
      ManageSecChange: function() {
        this.condition.section = ''
        this.secOptions = []
        this.LoadCPSec()
      },
      LoadCPSec: function() {
        var args = {
          token: this.condition.token,
          username: this.condition.username,
          rolelevel: this.condition.rolelevel,
          mamagesec: this.condition.secretarysec
        }
        var that = this
        this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIDictItem/CPSecList', args, function(data) {
          that.secOptions = data.Data
        }, null, null, null)
      }
    },
    mounted: function() {
      this.condition.token = sessionStorage.getItem('token')
      this.condition.username = sessionStorage.getItem('username')
      this.condition.rolelevel = sessionStorage.getItem('rolelevel')
      this.condition.secid = sessionStorage.getItem('secid')
      this.LoadManageSec()
      this.LoadCPSec()
      this.$refs.btnSearch.Search()
    }
  }
</script>

<style scoped="scoped">
::v-deep .el-input {
    width: 220px;
  }

::v-deep .tabTable tbody tr {
    height: 50px;
    line-height: 30px;
  }
</style>
